export const REGISTER_OPT_OUT = "REGISTER_OPT_OUT";
export const GET_PERSON_CONSENT = "GET_PERSON_CONSENT";
export const SET_PERSON_CONSENT = "SET_PERSON_CONSENT";
export const SAVE_PERSON_CONSENT = "SAVE_PERSON_CONSENT";
export const CHANGE_CONSENT_MODAL = "CHANGE_CONSENT_MODAL";
export const GET_GROUP_FOR_PERSON = "GET_GROUP_FOR_PERSON";
export const SET_GROUP_FOR_PERSON = "SET_GROUP_FOR_PERSON";
export const GROUP_PERSON = "GROUP_PERSON";
export const UNGROUP_PERSON = "UNGROUP_PERSON";
export const SET_PERSON_NAME = "SET_PERSON_NAME";
export const SET_NAME_LOADING = "SET_NAME_LOADING";
export const GET_PERSON_NAME = "GET_PERSON_NAME";
export const RESET_PERSON_NAME = "RESET_PERSON_NAME";

export const getPersonConsent = () => ({
  type: GET_PERSON_CONSENT,
});

export const resetPersonName = () => ({
  type: RESET_PERSON_NAME,
});

export const savePersonConsent = () => ({
  type: SAVE_PERSON_CONSENT,
});

export const setPersonConsent = (cardConsent: any) => ({
  type: SET_PERSON_CONSENT,
  cardConsent,
});

export const setPersonName = (name: any) => ({
  type: SET_PERSON_NAME,
  name,
});

export const setGroupForPerson = (groupForPerson: any) => ({
  type: SET_GROUP_FOR_PERSON,
  groupForPerson,
});

export const setNameLoading = (nameLoading: any) => ({
  type: SET_NAME_LOADING,
  nameLoading,
});

const initialState = {
  cardConsent: {
    exportRestriction: false,
    recurringCard: false,
    sendPostToCarePrincipal: false,
    optOut: false,
  },
  name: null,
  nameLoading: false,
};

export const personReducer = (state = initialState, action: any) => {
  var { name } = action;
  switch (action.type) {
    case RESET_PERSON_NAME:
      name = null;
      return { ...state, name };
    case SET_PERSON_NAME:
      return { ...state, name };
    case SET_NAME_LOADING:
      const { nameLoading } = action;
      return { ...state, nameLoading };
    case SET_PERSON_CONSENT:
      const { cardConsent } = action;
      return { ...state, cardConsent };
    case SET_GROUP_FOR_PERSON:
      const { groupForPerson } = action;
      return { ...state, groupForPerson };
    default:
      return state;
  }
};
